import { ErrorCode, SdkError } from '../hosted-web-content-sdk.interface';
import { ITelemetryScenario } from '../interfaces';

const internalErrorMessage = 'An internal error occurred';

export const defaultSdkError: SdkError = {
  errorCode: ErrorCode.INTERNAL_ERROR,
  message: internalErrorMessage,
};

export const onSdkError = (apiName: string, error: any, scenario?: ITelemetryScenario): Promise<unknown> => {
  scenario?.fail(`${apiName} Api failed ${error}`);

  if (isSdkError(error)) {
    return Promise.resolve(error);
  }

  return Promise.resolve(defaultSdkError);
};

export const onStatusError = (
  apiName: string,
  error: any,
  scenario?: ITelemetryScenario
): Promise<(boolean | string)[]> => {
  scenario?.fail(`${apiName} Api failed ${error}`);

  return Promise.resolve([false, error]);
};

export const formulateSdkResponse = async <TResult>(
  params: any,
  func: (params: any) => Promise<TResult>,
  resultTransform?: (result: TResult) => unknown,
  spreadFinalResult: boolean = false
): Promise<unknown> => {
  const result = await func(params);
  if (isSdkError(result)) {
    return Promise.reject(result);
  } else {
    const finalResult = resultTransform ? resultTransform(result) : result;
    if (spreadFinalResult && Array.isArray(finalResult)) {
      return Promise.resolve([null, ...finalResult]);
    } else {
      return Promise.resolve([null, finalResult]);
    }
  }
};

export const isSdkError = (error: any): error is SdkError => {
  if (error?.errorCode !== undefined) {
    return true;
  }
  return false;
};
